<template>
  <div class="dd-case">
    <div class="case-for-web">
      <div class="case-nav">
        <div class="case-nav-item-block" v-for="(item, index) in navList" :key="index">
          <div class="case-nav-item" :class="currentNavIdx === item.idx && currentNavIdx !== 7 ? 'nav-item-active': ''" @click="chooseNavOption(item.idx)">
            <div class="nav-item-arrow-block left">
              <i class="el-icon-caret-left nav-item-arrow" v-if="currentNavIdx === item.idx"></i>
            </div>
            <div class="nav-item-icon-block left">
              <img class="nav-item-icon" :src="item.activeIcon" v-if="currentNavIdx === item.idx"/>
              <img class="nav-item-icon" :src="item.icon" v-else/>
            </div>
            <div class="nav-item-title left">{{item.label}}</div>
          </div>
        </div>
        <div class="case-nav-item case-more">
          <div class="case-more-text left">更多案例&nbsp;&nbsp;&nbsp;&nbsp;》</div>
        </div>
      </div>
      <div class="case-guide">
        <span class="case-guide-item" :class="currentGuideIdx === 1 ? 'guide-item-active': ''" @click="chooseGuideOption(1)">实施成果</span>
        <span class="case-guide-item" :class="currentGuideIdx === 2 ? 'guide-item-active': ''" @click="chooseGuideOption(2)">解决的问题</span>
        <span class="case-guide-item" :class="currentGuideIdx === 3 ? 'guide-item-active': ''" @click="chooseGuideOption(3)">我们如何做的</span>
        <div class="clear"></div>
      </div>
      <div class="case-content">
        <g-lv-ji-page v-if="currentNavIdx === 1" :current-guide-idx="currentGuideIdx"/>
        <g-lu-page v-if="currentNavIdx === 2" :current-guide-idx="currentGuideIdx"/>
        <z-liu-jipage v-if="currentNavIdx === 3" :current-guide-idx="currentGuideIdx"/>
        <z-gui-page v-if="currentNavIdx === 4" :current-guide-idx="currentGuideIdx"/>
        <k-ya-ji-page v-if="currentNavIdx === 5" :current-guide-idx="currentGuideIdx"/>
        <d-du-page v-if="currentNavIdx === 6" :current-guide-idx="currentGuideIdx"/>
        <q-wei-ding-zhi-page v-if="currentNavIdx === 7" :current-guide-idx="currentGuideIdx"/>
      </div>
    </div>
  </div>
</template>

<script>
import GLvJiPage from './components/GLvJiPage.vue'
import DDuPage from './components/DDuPage.vue'
import GLuPage from './components/GLuPage.vue'
import ZLiuJipage from './components/ZLiuJiPage.vue'
import ZGuiPage from './components/ZGuiPage.vue'
import KYaJiPage from './components/KYaJiPage.vue'
import QWeiDingZhiPage from './components/QWeiDingZhiPage.vue'
export default {
  name: 'index',
  components: {
    GLvJiPage, DDuPage, GLuPage, ZLiuJipage, ZGuiPage, KYaJiPage, QWeiDingZhiPage
  },
  data () {
    return {
      currentNavIdx: 1,
      currentGuideIdx: 1,
      navList: [
        {
          idx: 1,
          icon: require('../../assets/img/case/case-nav-icon-01.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-01.png'),
          label: '智能水过滤机'
        },
        {
          idx: 2,
          icon: require('../../assets/img/case/case-nav-icon-02.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-02.png'),
          label: '锅炉设备'
        },
        {
          idx: 3,
          icon: require('../../assets/img/case/case-nav-icon-03.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-03.png'),
          label: '整流机设备'
        },
        /*
        {
          idx: 4,
          icon: require('../../assets/img/case/case-nav-icon-04.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-04.png'),
          label: '蒸柜设备'
        },
        */
        {
          idx: 5,
          icon: require('../../assets/img/case/case-nav-icon-05.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-05.png'),
          label: '空压机设备'
        },
        {
          idx: 6,
          icon: require('../../assets/img/case/case-nav-icon-06.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-06.png'),
          label: '电镀工厂'
        },
        {
          idx: 7,
          icon: require('../../assets/img/case/case-nav-icon-07.png'),
          activeIcon: require('../../assets/img/case/case-nav-icon-active-07.png'),
          label: '大功率电源'
        }
      ]
    }
  },
  created () {
    this.$root.isFill = true
    // 当设备为手机端是自动跳转到手机端页面
    if (this.$root.mFlag) {
      this.$router.replace({path: '/case/mobile/gLvJiPage'})
    }
  },
  methods: {
    chooseNavOption (idx) {
      if (idx !== 7) {
        this.currentNavIdx = idx
        this.currentGuideIdx = 1
      }
    },
    chooseGuideOption (idx) {
      this.currentGuideIdx = idx
    }
  }
}
</script>

<style scoped>
  .case-for-web {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background-color: lightgray;
    overflow: hidden;
  }
  .case-nav {
    width: 300px;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: rgba(1, 13, 28, .5);
    padding-top: 197px;
    box-sizing: border-box;
    z-index: 109;
  }
  .case-nav-item {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    border: 1px solid #010D1C;
    background-color: #062951;
    line-height: 78px;
    cursor: pointer;
  }
  .nav-item-active {
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .nav-item-arrow-block {
    width: 42px;
    height: 78px;
  }
  .nav-item-arrow {
    color: #fff;
    font-size: 18px;
    margin-left: 6px;
  }
  .nav-item-icon-block {
    height: 78px;
  }
  .nav-item-icon {
    display: inline-block;
    vertical-align: middle;
  }
  .nav-item-title {
    font-size: 16px;
    color: #ffffff;
    font-weight: bold;
    margin-left: 16px;
  }
  .case-more {
    height: 45px;
    line-height: 45px;
  }
  .case-more-text {
    font-size: 16px;
    font-weight: bold;
    color: #C752FB;
    margin-left: 30px;
  }
  .case-guide {
    width: 100%;
    padding: 0 320px 0 86px;
    margin-top: 168px;
    box-sizing: border-box;
    position: relative;
    z-index: 99;
  }
  .case-guide-item {
    border-radius: 18px;
    border: 1px solid lightgray;
    padding: 8px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    margin-right: 22px;
    cursor: pointer;
    background-color: #3031335e;
  }
  .case-guide-item:hover {
    background-color: #C6A109;
    border: unset;
  }
  .guide-item-active {
    background-color: #C6A109;
    border: unset;
  }
  .case-content {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
  .case-for-mobile {
    display: none;
    padding: 20px 15px;
    box-sizing: border-box;
  }
  .c-m-item {
    width: 100%;
    max-width: 300px;
    margin: auto;
    border: 1px solid lightgray;
    margin-bottom: 20px;
    border-radius: 6px;
    box-shadow: 3px 3px 3px lightgray;
  }
  .c-m-surface {
    width: 100%;
    height: 180px;
    border-radius: 6px 6px 0 0;
    overflow: hidden;
  }
  .c-m-surface img {
    height: 100%;
  }
  .c-m-content {
    padding: 10px;
    box-sizing: border-box;
    text-align: center;
    color: #010D1C;
  }
  .c-m-content-title {
    font-size: 16px;
    font-weight: 700;
    padding: 10px 0 10px;
  }
  .c-m-content-sub-title {
    font-size: 14px;
  }
  @media all and (max-width: 1200px) {
    .case-guide {
      padding: 0 320px 0 20px;
    }
  }
  @media all and (max-width: 1050px) {
    .case-nav {
      width: 230px;
      padding-top: 120px;
    }
    .case-nav-item {
      height: 60px;
      line-height: 58px;
    }
    .nav-item-arrow-block {
      height: 58px;
    }
    .nav-item-icon-block {
      height: 58px;
    }
    .case-guide {
      padding: 0 250px 0 20px;
      margin-top: 120px;
    }
  }
  @media all and (max-width: 760px) {
    .case-guide {
      width: 720px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/case/index.vue